import api from "./api";

// Export full company data(s) as complete database backup
// Downloads the Excel file directly as a blob and triggers browser download
export async function exportCompanyData(companyIds = []) {
  const ids =
    Array.isArray(companyIds) ? companyIds
    : companyIds != null ? [companyIds]
    : [];
  if (ids.length === 0) throw new Error("No companies selected");

  const query = ids
    .map((id) => `companyIds=${encodeURIComponent(id)}`)
    .join("&");

  // Make GET request expecting binary blob response
  const blob = await api.request(`/import/export-company?${query}`, {
    method: "GET",
    responseType: "blob",
  });

  if (!blob || !(blob instanceof Blob)) {
    throw new Error("Invalid export response - expected file data");
  }

  // Create download link and trigger download
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `company_backup_${new Date().toISOString().split("T")[0]}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

const exportService = { exportCompanyData };

export default exportService;
